import { getIndexName } from '../../constants';

const ALGOLIA_APP_ID = 'B4Y7NL266A';
const ALGOLIA_SEARCH_KEY = 'aeb4a0dce3009a6ed21e1d3ca4db3489'; // search-only key for browser

// Import algoliasearch/lite - Vite will exclude it from server bundle via ssr.external
// This import is safe because Vite handles it correctly with the SSR external config
import { liteClient as algoliasearch } from 'algoliasearch/lite';

export function getSearchClient() {
  // This function should only be called on the client (browser)
  if (typeof window === 'undefined') {
    throw new Error('getSearchClient() can only be called on the client side. algoliasearch/lite is browser-only.');
  }
  console.log('[algolia-client] Initializing search client for browser');
  return algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_KEY);
}

export function getIndex(locale: string) {
  const client = getSearchClient() as any;
  const indexName = getIndexName(locale);
  if (typeof window !== 'undefined') {
    console.log('[algolia-client] Using index', { locale, indexName });
  }
  // Cast to any to support lite client's initIndex at runtime without TS complaining
  return (client as any).initIndex(indexName);
}

export async function fetchJobsByObjectIDs(locale: string, objectIDs: string[]): Promise<any[]> {
  if (!objectIDs.length) return [];
  const index = getIndex(locale);
  // Prefer getObjects when available for exact retrieval by objectID
  // @ts-ignore - algoliasearch/lite provides getObjects on index in v4
  console.log('[algolia-client] fetchJobsByObjectIDs', { count: objectIDs.length });
  const res = await index.getObjects(objectIDs);
  const results: any[] = Array.isArray(res.results) ? res.results.filter(Boolean) : [];
  console.log('[algolia-client] fetchJobsByObjectIDs results', { matched: results.length });
  return results;
}

export async function fetchJobsByUrls(locale: string, urls: string[]): Promise<any[]> {
  if (!urls.length) return [];
  const client = getSearchClient();
  const indexName = getIndexName(locale);
  console.log('[algolia-client] fetchJobsByUrls', { count: urls.length, locale, indexName });
  // Build multiple queries restricting search to the url field to increase precision
  // This does not require url to be a facetable attribute
  const requests = urls.map((url) => ({
    indexName,
    params: {
      query: url,
      hitsPerPage: 1,
      restrictSearchableAttributes: ['url'],
      typoTolerance: 'min',
    },
  }));

  const searchResponse = await client.search(requests as any);
  const hits: any[] = [];
  for (const r of (searchResponse.results as any[])) {
    const first = r?.hits?.[0];
    if (first) hits.push(first);
  }
  console.log('[algolia-client] fetchJobsByUrls results', { matched: hits.length });
  return hits;
}
